import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';

import {
  SERVER_ERROR,
  LOGIN_ERROR
} from 'common-components/Alert/alertMessage.config';
import ProgressBar from 'common-components/ProgressBar';
import {
  setPublishNotificationSummary,
  setPublishSummary
} from 'redux/urls/url.action';
import {
  sendPublishedResultsToDb,
  publishUrls
} from '../../api';
import Alert from 'common-components/Alert';
import { BATCH_PUBLISH_OFSET } from '../../config';

import './publish.style.css';

const Publish = ({
  authHeader,
  setPublishNotificationSummary,
  setPublishSummary
}) => {
  const location = useLocation();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [alertData, setAlertData] = useState({});
  const [error, setError] = useState(false);

  const initiateBatchPublish = (location) => {
    let previousPublishedResult = JSON.parse(sessionStorage.getItem('publishedResult'));
    let urlsToPublish = JSON.parse(sessionStorage.getItem('urlsToPublish'));
    const parsedQuery = new URLSearchParams(location);
    const parsedResult = JSON.parse(parsedQuery.get('updates'));

    if (previousPublishedResult && previousPublishedResult.length > 0) {
      let aggregateResult = previousPublishedResult.concat(parsedResult);
      setPublishSummary(aggregateResult);
      sessionStorage.setItem('publishedResult', JSON.stringify(aggregateResult));
    } else {
      setPublishSummary(parsedResult);
      sessionStorage.setItem('publishedResult', JSON.stringify(parsedResult));
    };
    if (urlsToPublish && urlsToPublish.length > 0) {
      let payload = urlsToPublish.splice(0, BATCH_PUBLISH_OFSET);
      sessionStorage.setItem('urlsToPublish', JSON.stringify(urlsToPublish));
      publishUrls(payload, window.location.href.split('?')[0]);
    } else {
      let payload = sessionStorage.getItem('publishedResult');
      sessionStorage.removeItem('publishedResult');
      sessionStorage.removeItem('urlsToPublish');
      sendUrlStatus(payload);
    };
  };

  const sendUrlStatus = async (payload) => {
    let data;

    setIsLoading(true);
    let response = await sendPublishedResultsToDb(payload, authHeader);
    if (response && response.status == 401) setAlertData(LOGIN_ERROR);
    if (response && response.status == 400) {
      setAlertData({
        title: "Warning",
        description: "Repeated entry of URL created issue in WPV database.",
        eventName: 'Ok',
        showModal: true,
        type: 'info',
      });
      setError(true);
    } else if (response && response.status.toString().match(/2\d{2}/)) {
      data = response.data;
      setPublishNotificationSummary(data);
      history.push('/review_queue');
    } else setAlertData(SERVER_ERROR);
  };

  useEffect(() => {
    if (location) {
      setPublishNotificationSummary(null);
      initiateBatchPublish(location.search)
    };
  }, [location]);

  return (
    <>
      { error ? (
        <div className='redirection-message'>
          Kindly redirect manually to other page.
        </div>
      ) :
        isLoading && (
          <div className='progress-bar-container'>
            < ProgressBar
              done='100'
              timeout='1000'
              message='Loading sumarry. .'
            />
          </div>
        )
      }
      <Alert
        showModal={alertData.showModal}
        setShowModal={setAlertData}
        data={alertData}
      />
    </>
  );
};

const mapStateToProps = ({
  authentication: { authHeader } }) => ({
    authHeader
  });

const mapDispatchToProps = dispatch => ({
  setPublishNotificationSummary: data => dispatch(setPublishNotificationSummary(data)),
  setPublishSummary: payload => dispatch(setPublishSummary(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(Publish);

